import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { language } from './shared/language'
import { project } from './shared/project'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { AlmanacFile } from 'types'
import { TurnInto } from 'blaze-ui/icons/36'
import { ChannelOption } from '../CampaignWizard/Types'
import { channels } from './shared/channels'
import { brandKitId } from './shared/brandKitId'
import { Tone } from 'components/VoiceAndTonesSelect/Types'

export type Values = {
  filename?: string
  project?: AlmanacFile
  language?: string
  source_materials?: number[]
  transcription_id?: number
  focus?: string
  topic?: string
  channels?: Array<ChannelOption>
  file?: File
  content_url?: string
  brand_kit_id?: number
}

export type AdditionalPromptValues = { brand_visual_kit_id?: number; brand_voice_id?: number; tone: Tone[] }

const meta = {
  title: 'Turn Into',
  steps: ['Source', 'Turn Into', 'Confirm Details'],
  submitLabel: 'Generate Captions',
  icon: TurnInto,
  previewUrl: '',
  type: GenerationType.Campaign,
}

const fields = {
  filename: string().default('').meta({ hide: true }),
  project,
  language,
}

const confirmDetailsFields = {
  filename: string().default('').meta({ hide: true, autoFill: true }),
  brand_kit_id: brandKitId,
}

const confirmDetailsFieldsSingleDoc = {
  project: project.required(),
  ...confirmDetailsFields,
}

const confirmDetailsFieldsCampaign = {
  project: project
    .meta({ label: 'Name your campaign and select a location', placeholder: 'Name your campaign...' })
    .required(),
  ...confirmDetailsFields,
  channels: channels.meta({ skipReset: true }),
}

export const TurnIntoSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const ConfirmDetailsCampaignSchema = object(confirmDetailsFieldsCampaign).meta(meta) as FormSchema<
  GenerationType | ChannelType
>
export const ConfirmDetailsSingleDocSchema = object(confirmDetailsFieldsSingleDoc).meta(meta) as FormSchema<
  GenerationType | ChannelType
>
